// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#priority[data-v-95f06344] {\n\tdisplay: inline-block;\n}\n.app-content-list-item[data-v-95f06344]:hover {\n\tbackground-color: transparent;\n\topacity: 0.8;\n}\n", ""]);
// Exports
module.exports = exports;
